import { useState, useEffect, useRef } from 'react';
import CarouselV2 from '@common/Carousel/containers/CarouselV2';
import { useConfig } from '@common/Hooks/useConfig';
import { prepareTrackingDataAttributes } from '@common/Listing/helpers/tracking';
import ProductCard from '@common/ProductCard/containers/ProductCardRedesign';
import { CARD_TYPES } from '@common/ProductCard/helpers/constants';
import { REAL_LIST_VALUES, trackProductImpressions } from '@common/Tracking';
import { fetchCarouselProducts } from '../helpers/fetchCarouselProducts';

import '../styles/CarouselSection.scss';

function CarouselSectionMobile({
    hasImpressions,
    isSearchNoResult,
    data,
    hasToShowFavoriteButton = true,
    modifier,
    productCardType,
    reallistValue,
    url
}) {
    const containerRef = useRef();
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const config = useConfig();
    const hasConfigProperties = Object.keys(config).length > 0;

    const imageDimensions = hasConfigProperties
        ? Object.values(config.productCardImageDimensions)
        : App.Config.availableImageDimensions;

    const bigListingImageDimension = hasConfigProperties
        ? config.productCardImageDimensions.large
        : App.Config.imageDimensionListingBig;

    useEffect(() => {
        const handleProductsFetch = async () => {
            try {
                const response = await fetchCarouselProducts(url);
                setProducts(response.product_cards.slice(0, 15));
            } catch (error) {} finally {
                setIsLoading(false);
            }
        };

        if (isSearchNoResult) {
            setProducts(data);
            setIsLoading(false);
        } else {
            handleProductsFetch();
        }
    }, [data, isSearchNoResult, url]);

    useEffect(() => {
        if (hasImpressions && products.length > 0) {
            trackProductImpressions(containerRef.current);
        }
    }, [hasImpressions, products]);

    if (isLoading) {
        return <div className="is-loading" />;
    }

    return (
        <div ref={containerRef}>
            <CarouselV2
                group={REAL_LIST_VALUES.bestsellers}
                modifier={modifier}
            >
                {products.map((product, index) => (
                    <ProductCard
                        key={product.variants[0].ean_id}
                        hasToTrackImpressions
                        availableImageDimensions={imageDimensions}
                        className="product-card"
                        hasToShowFavoriteButton={hasToShowFavoriteButton}
                        imageSizes={{ dimension: bigListingImageDimension }}
                        product={product}
                        trackingValue={reallistValue || REAL_LIST_VALUES.frontPageCarousel}
                        trackingValues={{
                            bmp: {
                                itemIndex: index,
                                group: REAL_LIST_VALUES.bestsellers
                            },
                            dataAttributes: prepareTrackingDataAttributes({
                                product, index
                            })
                        }}
                        type={productCardType || CARD_TYPES.frontPageCarousel}
                    />
                ))}
            </CarouselV2>
        </div>
    );
}

export default CarouselSectionMobile;
